import axios from 'axios';
import utils from '@/common/util';
import { Config } from './config';
import router from '../../router';

axios.defaults.headers.post['Content-Type'] = Config.header; // 全局的 axios 默认值，设置post请求的默认content-type

const http = {
  _addParams: (params) => {
    if (params && utils.isObject(params)) {
      const headerJson = {
        SERVICE_ID: params.SERVICE_ID,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        OTYPE: params.OTYPE,
      };
      delete params.SERVICE_ID;
      delete params.SESSION;
      delete params.OTYPE;
      if (headerJson.SERVICE_ID) {
        const reqMsg = { REQUEST: { HDR: headerJson, DATA: params } };
        return JSON.stringify(reqMsg);
      }
      throw new Error('请检查相关参数的功能号(SERVICE_ID)');
    }
    throw new Error('请求参数不合法，请检查调用参数！');
  },
  post: (param) => {
    const params = http._addParams(param);
    return axios.post(Config.baseUrl, params).then((result) => {
      const code = result.data.ANSWER.HDR.CODE;
      if (code !== Config.ERR_CODE) {
        const TEXT = result.data.ANSWER.HDR.TEXT;
        if (TEXT === '验证不通过' || TEXT === '验证不通过，请从新登陆' || TEXT === '登陆已过期，请重新登陆' || TEXT === '登陆已过期，请从新登陆') {
          router.push('/login');
        }
        return Promise.reject(result.data.ANSWER.HDR.TEXT);
      }
      return result.data.ANSWER.DATA;
    });
  },
};

export default http;



// WEBPACK FOOTER //
// ./src/api/base/http.js